import { createRouter, createWebHistory } from "vue-router";
import HomeView from "@/views/home/HomeView.vue";
import { menuConfig } from "@/views/dashboard/menuConfig";

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: "/",
      name: "home",
      component: HomeView,
    },
    {
      path: "/privacy-policy",
      name: "PrivacyPolicy",
      beforeEnter() {
        window.location.href = "/privacy-policy.html";
      },
    },
    {
      path: "/c/:code",
      name: "collection",
      component: () => import("@/views/collection/CollectionView.vue"),
      props: true,
      beforeEnter: (to, from, next) => {
        const code = to.params.code;
        // 验证code是否为有效的36进制数（最多6位）
        const isValid = /^[0-9a-z]{1,6}$/i.test(code);
        if (!isValid) {
          next('/');
          return;
        }
        next();
      },
    },
    {
      path: "/:primaryMenu/:secondaryMenu",
      component: () => import("@/views/dashboard/DashBoard.vue"),
      props: true,
      beforeEnter: (to, from, next) => {
        const { primaryMenu, secondaryMenu } = to.params;

        // 检查一级菜单是否存在
        const primaryMenuExists = menuConfig[primaryMenu];
        if (!primaryMenuExists) {
          next("/"); // 或者跳转到 404
          return;
        }

        // 检查二级菜单是否存在
        const secondaryMenuExists = primaryMenuExists.items.some(
          (item) => item.key === secondaryMenu
        );

        if (!secondaryMenuExists) {
          next("/"); // 或者跳转到 404
          return;
        }

        next();
      },
    },
    {
      path: "/:relativeUrl",
      component: () => import("@/views/easyfile/EasyFileView.vue"),
      props: true,
    },
  ],
});

export default router;
